/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions

==========================================================================================*/

import jwt from '../../services/jwt';
import router from '@/router';

export default {
  refreshUserObject({ commit }) {
    return new Promise((resolve, reject) => {
      jwt
        .refreshUserObject()
        .then((response) => {
          if (response.data) {
            commit('UPDATE_USER_INFO', response.data, { root: true });

            return resolve(response.data);
          }

          reject(response.data);
        })
        .catch((exception) => reject(exception));
    });
  },
  refreshCourseObject({ commit }) {
    return new Promise((resolve, reject) => {
      jwt
        .refreshCourseObject()
        .then((response) => {
          if (response.data) {
            let courseInfo = response.data;

            if (response.data === 'none') {
              localStorage.removeItem('courseInfo');
              courseInfo = null;
            }

            if (response.data !== 'none') {
              courseInfo.active = true;
            }

            commit('UPDATE_COURSE_INFO', courseInfo, { root: true });

            return resolve(response.data);
          }

          reject(response.data);
        })
        .catch((exception) => reject(exception));
    });
  },
  // JWT
  loginJWT({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .login(payload.loginToken, payload.challengeCode, payload.password, payload.turnstileToken)
        .then((response) => {
          // If there's user data in response
          if (response.data) {
            // Navigate User to homepage
            const data = response.data;

            // Set accessToken
            // localStorage.setItem('accessToken', data.accessToken);
            // localStorage.setItem('refreshToken', data.refreshToken);

            //if (data.user.firstName) {
            //   data.user.full_name = `${data.user.firstName} ${data.user.lastName}`;
            // }

            // Update user details
            commit('UPDATE_USER_INFO', data.user, { root: true });

            // Set bearer token in axios
            // commit('SET_BEARER', data.accessToken);

            // Go To Dashboard
            router.push('/dashboard');

            resolve(response);
          } else {
            reject({ message: 'Wrong Email or Password' });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchAccessToken() {
    return new Promise((resolve) => {
      jwt
        .refreshToken()
        .then((response) => {
          resolve(response);
        })
        .catch((exception) => {
          throw exception;
        });
    });
  },
};
